import { HTMLAttributes, useState } from 'react'
import Calendar from 'react-calendar'
import { useLocale } from 'use-intl'
import { useTranslations } from 'next-intl'
import clsx from 'classnames'
import { ArrowXAxisIcon } from '@/shared/icons/arrow-x-axis-icon'
import CalendarIcon from '@/public/calendar-icon.svg'
import { Button } from '@/shared/ui'
import './date-picker.scss'
import { Popover, PopoverContent, PopoverTrigger } from '@/shared/ui/popover'
import { getDateRangeFormat } from '@/shared/utils'
import { localeMap } from '@/shared/utils/directus'
import { ActionFooter } from './action-footer'
import style from './date-picker.module.scss'

export type Range<T> = [T, T]
type ValuePiece = Date | null
export type Value = ValuePiece | Range<ValuePiece>
export type DateRange = Range<ValuePiece>

type DatePickerProps = HTMLAttributes<HTMLDivElement> & {
  onDateChange: (dateRange: Value) => void
  initDate?: Value
}

export const DatePicker = ({ className, onDateChange, initDate = null }: DatePickerProps) => {
  const [value, onChange] = useState<Value>(initDate)
  const calendarButtons = useTranslations('CalendarButtons')
  const title = value ? getDateRangeFormat(value) : calendarButtons('selectDate')
  const currentLocale = useLocale()

  const onReset = () => {
    onDateChange(null)
    onChange(null)
  }

  return (
    <Popover>
      <PopoverTrigger>
        <Button className={className} size="l" prefix={<CalendarIcon />}>
          {title}
        </Button>
      </PopoverTrigger>
      <PopoverContent>
        <div className={style.container}>
          <Calendar
            onChange={onChange}
            value={value}
            locale={localeMap[currentLocale]}
            selectRange
            nextLabel={<ArrowXAxisIcon className={clsx(style.arrow, 'arrow-icon')} direction="next" />}
            prevLabel={<ArrowXAxisIcon className={clsx(style.arrow, 'arrow-icon')} direction="prev" />}
          />
          <ActionFooter disabled={!value} onReset={onReset} onClick={() => onDateChange(value)} />
        </div>
      </PopoverContent>
    </Popover>
  )
}
